export const removeDuplicates = (originalArray, prop) => {
    const lookup = {};
    for (let item of originalArray) {
      lookup[item[prop]] = item;
    }
    return Object.values(lookup);
  };
  
  export const getAllAssignedMembers = ({
    taskMembers,
    projectMembers,
    context,
    isCreate,
    selectedMembersOwner,
    setAssignedOwners,
    setSelectedMembersOwner,
    setAssignedMembers,
    setAssignedOtherDepMembers,
    setPermissionTaskMembers,
    setFilterAssignedMembers,
    setFilteredOtherDepMembers
  }) => {
    let currMembers = [];
    let filterMembersNames = [];
    let otherFilterMembersNames = [];
    let permissionMembers = [];
    let otherMembers = [];

    let owners = [];
    let selectedOwners = [];
  
    if (!isCreate) {
      owners = selectedMembersOwner
        .map(id => {
          const match = taskMembers.find(m => m.UserId === id);
          return match ? match.User : null;
        })
        .filter(Boolean);
    } else {
      const matchedOwner = projectMembers.find(
        m => m.User.Id === context.userID && !m.IsGroup
      );
      if (matchedOwner) {
        owners = [matchedOwner.User];
        selectedOwners = [matchedOwner.User.Id];
      }
    }

    taskMembers.forEach(member => {
      filterMembersNames.push(member.User.Name);
      currMembers.push(member.User);
      permissionMembers.push({
        Id: member.UserId,
        canApprove: member.CanApprove,
        canEdit: member.CanEdit || member.IsAssigned,
        canReassign: member.CanReassign,
        canView: member.CanView,
        IsGroup: member.IsGroup,
        // Archived/moved assignees are absent from the assignable pool; carry the
        // flag and a render-ready object so the chips can fall back to it (TAD-5898).
        Archived: member.IsGroup ? member.Archived === true : member.User?.Archived === true,
        Member: member.IsGroup
          ? { ...member, Archived: member.Archived === true, Members: member.GroupMembers || [] }
          : member.User,
      });
    });
  
    projectMembers.forEach(member => {
      otherFilterMembersNames.push(member.User.Name);
      if (member?.Group?.Id > 0) {
        member.Group.IsGroup = true;
        otherMembers.push(member.Group);
      } else {
        otherMembers.push(member.User);
      }
    });
  
    const uniqueMembers = removeDuplicates(currMembers.filter(x => !x.IsGroup), "Id");
    const uniqueGroups = removeDuplicates(currMembers.filter(x => x.IsGroup), "Id");
    const uniqueOtherMembers = removeDuplicates(otherMembers.filter(x => !x.IsGroup), "Id");
    const uniqueOtherGroups = removeDuplicates(otherMembers.filter(x => x.IsGroup), "Id");
    const uniquePermissionMembers = removeDuplicates(permissionMembers.filter(x => !x.IsGroup), "Id");
    const uniquePermissionGroups = removeDuplicates(permissionMembers.filter(x => x.IsGroup), "Id");

    if (owners.length) setAssignedOwners(owners);
    if (selectedOwners.length) setSelectedMembersOwner(selectedOwners);
  
    setAssignedMembers([...uniqueMembers, ...uniqueGroups]);
    setAssignedOtherDepMembers([...uniqueOtherMembers, ...uniqueOtherGroups]);
    setPermissionTaskMembers([...uniquePermissionMembers, ...uniquePermissionGroups]);
    setFilterAssignedMembers([...new Set(filterMembersNames)]);
    setFilteredOtherDepMembers([...new Set(otherFilterMembersNames)]);
  };

  export const addMembersInForm = ({
    permission,
    id,
    isGroup = false,
    selectedMembers,
    selectedGroups,
    setSelectedMembers,
    setSelectedGroups
  }) => {
    const members = isGroup ? [...selectedGroups[permission]] : [...selectedMembers[permission]];
    const index = members.indexOf(id);
    if (index > -1) members.splice(index, 1);
    members.push(id);
  
    if (isGroup) {
      setSelectedGroups[permission](members);
    } else {
      setSelectedMembers[permission](members);
    }
  };
  
  export const removeMembersInForm = ({
    permission,
    id,
    isGroup = false,
    selectedMembers,
    selectedGroups,
    setSelectedMembers,
    setSelectedGroups
  }) => {
    let updated = isGroup ? [...selectedGroups[permission]] : [...selectedMembers[permission]];
    updated = updated.filter(member => member !== id);
  
    if (isGroup) {
      setSelectedGroups[permission](updated);
    } else {
      setSelectedMembers[permission](updated);
    }
  };